import { useState } from 'react';

import PropTypes from 'prop-types';

import Alert from '#globalComponents/Alert/Alert';
import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';
import FormField from '#globalComponents/Forms/FormField';
import Select from '#globalComponents/Forms/Select';
import TextInput from '#globalComponents/Forms/TextInput';
import { getErrorMessage } from '#lib/errors/errorMessages';
import { useInviteMember } from '#orgFeature/models/org/mutations';

export const InviteMember = ({ seatsAvailable }) => {
	const [email, setEmail] = useState('');
	const [role, setRole] = useState('member');
	const [result, setResult] = useState(null);

	const inviteMutation = useInviteMember();

	const handleSubmit = (e) => {
		e.preventDefault();
		setResult(null);

		if (!email.trim()) return;

		inviteMutation.mutate(
			{ email: email.trim(), role },
			{
				onSuccess: ({ mailSent }) => {
					setResult({ email, mailSent });
					setEmail('');
					setRole('member');
				},
			},
		);
	};

	const canInvite = seatsAvailable > 0;

	return (
		<Card>
			<h3 className="mb-4 text-sm font-semibold text-text">Mitglied einladen</h3>

			{!canInvite && (
				<Alert tone="caution" className="mb-4">
					Keine freien Plätze verfügbar. Upgraden Sie Ihren Plan für weitere Plätze.
				</Alert>
			)}

			<form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row sm:items-end">
				<FormField label="E-Mail-Adresse" htmlFor="invite-email" className="min-w-0 flex-1">
					<TextInput
						id="invite-email"
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="name@firma.de"
						required
						disabled={!canInvite}
					/>
				</FormField>
				<FormField label="Rolle" htmlFor="invite-role" className="w-full sm:w-36">
					<Select
						id="invite-role"
						value={role}
						onChange={(e) => setRole(e.target.value)}
						disabled={!canInvite}
					>
						<option value="member">Mitglied</option>
						<option value="admin">Admin</option>
					</Select>
				</FormField>
				<Button type="submit" disabled={!canInvite} loading={inviteMutation.isPending}>
					Einladen
				</Button>
			</form>

			{inviteMutation.isError && (
				<p className="mt-3 text-sm text-warning-700">{getErrorMessage(inviteMutation.error)}</p>
			)}
			{result?.mailSent && (
				<p className="mt-3 text-sm text-success-700">Einladung an {result.email} wurde gesendet.</p>
			)}
			{result && !result.mailSent && (
				<p className="mt-3 text-sm text-warning-700">
					Einladung an {result.email} wurde angelegt, die E-Mail konnte aber nicht zugestellt werden.
				</p>
			)}
		</Card>
	);
};

InviteMember.propTypes = {
	seatsAvailable: PropTypes.number.isRequired,
};
